// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"219":"review","357":"ai-creation","552":"publish","594":"about","709":"order","782":"purchase","945":"dashboard","962":"home"}[chunkId] + "." + {"219":"39777fea","357":"7a89b199","552":"ae4fcd75","594":"709fd1a5","709":"950324f2","782":"1135d1de","945":"2f2ccc90","962":"75a01dc7"}[chunkId] + ".css";
};